import type { OutputSpec } from './types'

/**
 * P10-3 (2026-09-06): the output sizes the export tab lets the user switch
 * between (`Composition.output`). Every preset keeps the SHORT side at 1080px,
 * so the absolute telop px sizes (`FreeTextOverlay.sizePx`, the title/label/
 * end-card font tables in server/src/telop/kinds/*) mean the same thing in
 * every preset — there is deliberately NO per-aspect font scaling anywhere.
 * fps is not part of a preset (the app renders at 30 only; see engine's
 * OUTPUT_FPS). docs/COMPOSER_CONTRACT.md dest='x' (1080x1350) is the '4:5'
 * preset — kept identical on purpose.
 */
export type OutputPresetId = '9:16' | '4:5' | '1:1' | '16:9'

export interface OutputPreset {
  id: OutputPresetId
  /** UI label (Japanese). */
  label: string
  width: number
  height: number
}

export const OUTPUT_PRESETS: readonly OutputPreset[] = [
  { id: '9:16', label: '縦 9:16（TikTok / Reels / Shorts）', width: 1080, height: 1920 },
  { id: '4:5', label: '4:5（X / Instagram フィード）', width: 1080, height: 1350 },
  { id: '1:1', label: '正方形 1:1', width: 1080, height: 1080 },
  { id: '16:9', label: '横 16:9（YouTube）', width: 1920, height: 1080 },
]

/** What every Composition got before P10-3 (engine/src/autoEdit.ts hardcoded this). */
export const DEFAULT_OUTPUT: OutputSpec = { width: 1080, height: 1920, fps: 30 }

/** Preset whose width/height match `output` exactly, else 'custom' (hand-edited JSON, legacy sizes). */
export function outputPresetIdFor(output: Pick<OutputSpec, 'width' | 'height'>): OutputPresetId | 'custom' {
  const hit = OUTPUT_PRESETS.find((p) => p.width === output.width && p.height === output.height)
  return hit ? hit.id : 'custom'
}

/** OutputSpec for a preset, keeping the caller's fps (default 30). */
export function outputForPreset(id: OutputPresetId, fps: number = DEFAULT_OUTPUT.fps): OutputSpec {
  const p = OUTPUT_PRESETS.find((x) => x.id === id)
  if (!p) throw new Error(`unknown output preset: ${id}`)
  return { width: p.width, height: p.height, fps }
}
